import React from "react";
import { useGameState } from "context/GameContext";
// Comps
import Player from "./components/Player/Player";
// Css
import classes from "./Players.module.scss";

const Players: React.FC = () => {
  const { players, playersNumber } = useGameState();

  return (
    <div className={classes.container}>
      {players.map((player, index) => (
        <Player player={player} index={index} key={index} />
      ))}
      {[...Array(10 - playersNumber)].map((item, index) => (
        <div key={index} className={classes.fake_player} />
      ))}
    </div>
  );
};

export default Players;
